import {
  ImageWithMetadata,
  inmarketLogoV2,
  resizeToHeight,
} from '@features/powerpoint';
import { ImageProps, Slide } from '@features/powerpoint';
import { Campaign } from '@features/campaigns';
import { titleImage } from '@features/executive-report/images';
import { themeV2 as theme } from '../../domain/theme-v2';
import { slideMasters } from '@features/executive-report/utils/slide-masters';

const BRAND_LOGO_HEIGHT = 1.15;
const BRAND_LOGO_Y_POSITION = 2.15;

export const titleSlide = (
  campaign: Pick<Campaign, 'id'>,
  brandLogoWithMetadata: ImageWithMetadata | null,
  campaignName: string
): Slide => {
  const brandLogoImage: ImageProps[] = brandLogoWithMetadata
    ? [
        (() => {
          const resizedBrandLogo = resizeToHeight(
            brandLogoWithMetadata,
            BRAND_LOGO_HEIGHT,
            1.11
          );

          const yPosition =
            resizedBrandLogo.height < BRAND_LOGO_HEIGHT
              ? BRAND_LOGO_Y_POSITION +
                (BRAND_LOGO_HEIGHT - resizedBrandLogo.height) / 2
              : BRAND_LOGO_Y_POSITION;

          return {
            data: resizedBrandLogo.data,
            x: 0.45,
            y: yPosition,
            w: resizedBrandLogo.width,
            h: resizedBrandLogo.height,
          };
        })(),
      ]
    : [];

  return {
    slideMaster: slideMasters.title,
    images: [
      {
        path: inmarketLogoV2,
        x: 0.45,
        y: 1.51,
        w: 1.87,
        h: 0.33,
      },
      {
        path: titleImage,
        h: 6.92,
        w: 6.1,
        x: 6.91,
        y: 0.3,
      },
      ...brandLogoImage,
    ],
    texts: [
      {
        text: [
          {
            text: 'End of Campaign',
          },
          {
            text: 'Report',
            options: {
              softBreakBefore: true,
            },
          },
        ],
        options: {
          color: theme.colors.metricBlue,
          bold: true,
          fontSize: 44,
          lineSpacingMultiple: 0.9,
          h: 3.12,
          w: 11.5,
          x: 0.33,
          y: 1.87,
          valign: 'bottom',
        },
      },
      {
        text: [
          {
            text: campaignName,
            options: {
              breakLine: true,
            },
          },
          {
            text: campaign.id.toString(),
            options: {
              paraSpaceBefore: 10,
            },
          },
        ],
        options: {
          color: theme.colors.metricBlue,
          bold: true,
          fontSize: 14,
          valign: 'top',
          h: 1.64,
          w: 11.5,
          x: 0.33,
          y: 5.02,
        },
      },
    ],
  };
};
